import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy, ViewChild, ElementRef, Output, QueryList } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import * as CryptoJS from 'crypto-js';
import { NavigationService } from 'src/app/services/navigation.service';
import { ZoneService } from 'src/app/services/zone.service';
import { EventNavbarService } from 'src/app/services/event-navbar.service';
import { ContratistasService } from 'src/app/services/contratistas.service';
import { EmpresasService } from 'src/app/services/empresas.service';
import { UserService } from 'src/app/services/user.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ROL, DELIMITADOR_, DELIMITADO__ } from 'src/app/utils/constants';
import { CategoryService } from 'src/app/services/category.service';
import { EjecutorService } from 'src/app/services/ejecutor.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
	selector: 'app-mantenedores',
	templateUrl: './mantenedores.component.html',
	styleUrls: ['./mantenedores.component.scss']
})
export class MantenedoresComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild(DataTableDirective, { static: false })
	dtElementUsuario: DataTableDirective;
	dtTriggerUsuario: Subject<any> = new Subject();
	/*dtInstanceUsuario: DataTables.Api;
	dtOptions: DataTables.Settings = {
		pagingType: 'full_numbers',
		pageLength: 10,
		language: {
			processing: 'Procesando...',
			search: 'Buscar:',
			lengthMenu: 'Mostrar _MENU_ registros',
			info: 'Mostrando desde _START_ al _END_ de _TOTAL_ registros',
			infoEmpty: 'Mostrando ningún registro.',
			infoFiltered: '(filtrado _MAX_ registros en total)',
			infoPostFix: '',
			loadingRecords: 'Cargando registros...',
			zeroRecords: 'No se encontraron registros',
			emptyTable: 'No hay datos disponibles en la tabla',
			paginate: {
				first: 'Primero',
				previous: 'Anterior',
				next: 'Siguiente',
				last: 'Último'
			},
			aria: {
				sortAscending: ': Activar para ordenar la tabla en orden ascendente',
				sortDescending: ': Activar para ordenar la tabla en orden descendente'
			}
		},
		responsive: true
	};*/
	userIdSelected: number;
	zonaIdSelected: number;
	confirmationModalTittle: string;
	confirmationModalMessage: string;
	confirmationModalHasComment = false;
	confirmationModalHasOptions = false;
	confirmationModalisCommentObligatory = false;
	confirmationModalOptionLabel: string;
	usuarioSelected: any;
	zonaSelected: any;
	categoriaSelected: any;
	confirmationModalOptions: { label: string, value: any }[];
	loadingUsuarios = false;
	loadingZonas = false;
	confirmationModalAccept: any;
	message = '';
	zonasMantenedor: any;
	zonas: any;
	categorias: any;
	ejecutores: any;
	userZonas: any;
	focoCategorias: any;
	relatorEjecutores: any;
	allZonas: any;
	allCategorias: any;
	allEjecutores: any;
	allEmpresas: any;
	contratistas: any;
	usuarios: any;
	usuariosFilter: any;
	visible = false;
	usuario: any;
	zona: any;
	categoria: any;
	enfoque: any;
	ejecutor: any;
	relator: any;
	planificacion: any;
	foco: any;
	empresas: any;
	flagRealizadas = false;
	flagPlanificadas = false;
	flagUsuarios = true;
	flagZonas = false;
	flagCategorias = false;
	flagEnfoques = false;
	flagEjecutores = false;
	flagFocos = false;
	flagRelatores = false;
	flagPlanificacion = false;
	rolid: any;
	flagReforzamiento = false;
	creationMode: string;
	pageActual: number = 1;
	secretKey: string = "";
	searchT: string = "";
	inputMessageModal: string = "";
	inputMessageModal2: string = "Espere un momento mientras se cargan los datos ...";
	constructor(private navigationService: NavigationService,
		private modalService: NgbModal,
		private httpClient: HttpClient,
		private changeDetectorRefs: ChangeDetectorRef,
		private contratistasService: ContratistasService,
		private empresasService: EmpresasService,
		private userService: UserService,
		private eventNavbarService: EventNavbarService,
		private zoneService: ZoneService,
		private categoriaService: CategoryService,
		private ejecutorService: EjecutorService,
		private loginService: LoginService) { }

	ngOnInit() {
		//$("#contenedor").css('display', 'grid')
		this.loginService.obtenerPermisosMenu('mantenedores').then((response) => {
			this.rolid = response.data.rolId
		})

		this.loginService.getkeyWord().then((response) => {
			this.secretKey = String(response.data).substring(Number(atob(DELIMITADOR_)),Number(atob(DELIMITADO__)));
		}).catch((error) => {
			console.log(error)
			console.error('ha ocurrido un error inesperado')
		});
	

		this.refresh();
		this.visible = true;
		this.loadingUsuarios = true;
		this.openNavbar();
		if (!sessionStorage.getItem('foo')) {
			sessionStorage.setItem('foo', 'no reload');
			// location.reload();
		} else {
			sessionStorage.removeItem('foo');
		}
		if (!this.navigationService.getValidLogin()) { this.navigationService.goTo('/login'); }
	}

	ngAfterViewInit(): void {
		this.dtTriggerUsuario.next();
		//$("#buttonLoadingTest").trigger('click'); 
	}

	ngOnDestroy(): void {
		this.pageActual = 1;
		this.dtTriggerUsuario.unsubscribe();
	}

	rerenderUsuario(): void {
		//this.modalService.dismissAll();
		this.loadingUsuarios = false;
		this.inputMessageModal = "";
		this.dtElementUsuario.dtInstance.then((dtInstanceUsuario: DataTables.Api) => {
			dtInstanceUsuario.destroy();
			this.dtTriggerUsuario.next();
		});
	}

	filterZone(zone: string) {
	}

	filterContratista(contratista: string) {
	}

	filterEnterprise(empresa: string) {
	}

	getZonas(): any {
		return new Promise((resolve, reject) => {
			this.zoneService.getZonas()
				.then(response => {
					this.zonas = response;
				})
				.catch(error => reject(error));
		});
	}

	getAllZonas(): any {
		return new Promise((resolve, reject) => {
			this.zoneService.getAllZonas()
				.then(response => {
					this.allZonas = response;
				})
				.catch(error => reject(error));
		});
	}

	getAllZonasUser(): any {
		return new Promise((resolve, reject) => {
			this.zoneService.getAllZonas()
				.then(response => resolve(response))
				.catch(error => reject(error));
		});
	}

	getAllCategorias(): any {
		return new Promise((resolve, reject) => {
			this.categoriaService.getAllCategorias()
				.then(response => resolve(response))
				.catch(error => reject(error));
		});
	}

	getAllEjecutores(): any {
		return new Promise((resolve, reject) => {
			this.ejecutorService.getAllCategorias()
				.then(response => resolve(response))
				.catch(error => reject(error));
		});
	}

	getUserZonasByUserId(userid: String): any {
		return new Promise((resolve, reject) => {
			this.zoneService.getZonasbyUserId(userid)
				.then(response => resolve(response))
				.catch(error => reject(error));
		});
	}

	getContratistas(): any {
		return new Promise((resolve, reject) => {
			this.contratistasService.getContatistas()
				.then(response => {
					this.contratistas = response;
				})
				.catch(error => reject(error));
		});
	}

	getUsuarios(): any {
		return new Promise((resolve, reject) => {
			this.userService.listUsuariosZonas()
				.then(response => resolve(response))
				.catch(error => reject(error));
		});
	}

	getEmpresas(): any {
		return new Promise((resolve, reject) => {
			this.empresasService.getEmpresas()
				.then(response => {
					this.empresas = response;
				})
				.catch(error => reject(error));
		});
	}

	openNavbar() {
		this.eventNavbarService.openNavbar();
	}

	openDeleteModalUsuario(modal: any, usuario: any): void {
		this.usuario = usuario;
		this.confirmationModalHasComment = false;
		this.confirmationModalHasOptions = false;
		this.confirmationModalisCommentObligatory = false;
		this.userIdSelected = usuario.userId;
		this.confirmationModalTittle = 'Eliminar Usuario';
		this.confirmationModalMessage = `¿Seguro que desea eliminar al usuario "${usuario.username}"?`;
		this.confirmationModalAccept = this.onDeleteUser;
		this.openModal(modal);
	}

	openModal(modal: any, options: any = {}): void {
		const modalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, ...options };
		this.modalService.open(modal, modalOptions);
	}

	onDeleteUser(): void {

		this.userService.delete(this.usuario.userId)
			.then(response => {
				console.log('Response Body')
				console.log(response);
				this.refresh();
			})
			.catch(error => console.error(error));
	}

	onCreate(modal: any, mode: string, usuario: any) {
		if (mode === 'Editar') {
			const request: JSON = {
				userId: usuario.userId,
				rolId: usuario.roleId,
				userName: usuario.username,
				password: usuario.password,
				email: usuario.email,
				rut_trabajador: usuario.rutTrabajador,
				nombre_trabajador: usuario.nombreTrabajador,
				apellido_paterno: usuario.apellidoPaterno,
				apellido_materno: usuario.apellidoMaterno,
				estado: usuario.status,
				rut_empresa: usuario.rutContratista,
				nombre_empresa: usuario.nombreContratista,
				cargo: usuario.cargo,
				proceso: usuario.proceso,
				gerencia: usuario.gerencia,
				idEmpresa: usuario.idEmpresa,
				usuarioEncargado: usuario.usuarioEncargado,
				IdEncargado: usuario.usuarioEncargado
			} as unknown as JSON;
			this.usuarioSelected = request;
		} else {
			const request: JSON = {
				userId: null,
				rolId: null,
				userName: '',
				password: '',
				email: '',
				rut_trabajador: '',
				nombre_trabajador: '',
				apellido_paterno: '',
				apellido_materno: '',
				estado: 1, // Estado habilitado para el usuario que se creará
				rut_empresa: '',
				nombre_empresa: '',
				cargo: '',
				proceso: '',
				gerencia: '',
				idEmpresa: null,
				usuarioEncargado: null,
				IdEncargado: null
			} as unknown as JSON;
			this.usuarioSelected = request;
			this.userZonas = [];
		}
		const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
		this.creationMode = mode;

		if (mode === 'Editar') {
			Promise.all([
				this.getUserZonasByUserId(usuario.userId),
				this.getAllZonasUser()
			])
				.then(results => {
					this.userZonas = results[0];
					this.allZonas = results[1];
					this.modalService.open(modal, modalOptions);
				})
				.catch(error => console.error(error));
		} else {
			Promise.all([
				this.getAllZonasUser()
			])
				.then(results => {
					this.allZonas = results[0];
					this.modalService.open(modal, modalOptions);
				})
				.catch(error => console.error(error));
		}
	}

	onCreateZona(modal: any, mode: string, zona: any) {
		const request: JSON = {
			zoneId: null,
			descripcion: '',
			comuna: '',
			estado: 1
		} as unknown as JSON;
		this.zonaSelected = request;
		const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
		this.creationMode = mode;
		this.modalService.open(modal, modalOptions);
	}

	onCreateEnfoque(modal: any, mode: string, zona: any) {
		const request: JSON = {
			enfoqueId: null,
			descripcion: '',
			estado: 1
		} as unknown as JSON;
		this.categoriaSelected = request;
		const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
		this.creationMode = mode;
		this.modalService.open(modal, modalOptions);
	}

	onCreateEjecutor(modal: any, mode: string, zona: any) {
		const request: JSON = {
			ejecutorId: null,
			descripcion: '',
			estado: 1
		} as unknown as JSON;
		this.categoriaSelected = request;
		const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
		this.creationMode = mode;
		this.modalService.open(modal, modalOptions);
	}

	onCreateFoco(modal: any, mode: string, zona: any) {
		const request: JSON = {
			focoId: null,
			descripcion: '',
			estado: 1
		} as unknown as JSON;
		this.categoriaSelected = request;
		this.focoCategorias = [];
		const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'xl' };
		this.creationMode = mode;
		Promise.all([
			this.getAllCategorias()
		])
			.then(results => {
				this.allCategorias = results[0];
				this.modalService.open(modal, modalOptions);
			})
			.catch(error => console.error(error));
	}

	onCreateRelator(modal: any, mode: string, zona: any) {
		const request: JSON = {
			relatorId: null,
			descripcion: '',
			estado: 1
		} as unknown as JSON;
		this.categoriaSelected = request;
		this.relatorEjecutores = [];
		const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
		this.creationMode = mode;
		Promise.all([
			this.getAllEjecutores()
		])
			.then(results => {
				this.allEjecutores = results[0];
				this.modalService.open(modal, modalOptions);
			})
			.catch(error => console.error(error));
	}

	onCreatePlanificacion(modal: any, mode: string, zona: any) {
		const request: JSON = {
			codigo: '',
			descripcion: '',
			fechaInicio: '',
			fechaTermino: '',
			estado: 1
		} as unknown as JSON;
		this.categoriaSelected = request;
		this.relatorEjecutores = [];
		const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
		this.creationMode = mode;
		this.modalService.open(modal, modalOptions);
	}

	onCreateCategoria(modal: any, mode: string, zona: any) {
		const request: JSON = {
			categoriaId: null,
			descripcion: '',
			estado: 1
		} as unknown as JSON;
		this.categoriaSelected = request;
		const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
		this.creationMode = mode;
		this.modalService.open(modal, modalOptions);
	}

	onOpenModal(modal: any, mode: string) {
		const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg', keyboard: false, backdrop: 'static' };
		this.creationMode = mode;
		this.modalService.open(modal, modalOptions);
	}

	refresh() {
		this.loadingUsuarios = true;
		Promise.all([
			this.getUsuarios()
		])
			.then(results => {
				//console.log(results);
				console.log("Key ")
				console.log(this.secretKey)

				results[0].map((user) => {
					user.usuario.userId = Number(this.decrypt(user.usuario.userId  , this.secretKey));
					user.usuario.roleId = Number(this.decrypt(user.usuario.roleId  , this.secretKey));
					user.usuario.username = this.decrypt(user.usuario.username  , this.secretKey);
					user.usuario.email = this.decrypt(user.usuario.email  , this.secretKey);
					user.usuario.rutTrabajador = this.decrypt(user.usuario.rutTrabajador  , this.secretKey);
					user.usuario.nombreTrabajador = this.decrypt(user.usuario.nombreTrabajador  , this.secretKey);
					user.usuario.apellidoPaterno = this.decrypt(user.usuario.apellidoPaterno  , this.secretKey);
					user.usuario.apellidoMaterno = this.decrypt(user.usuario.apellidoMaterno  , this.secretKey);
					user.usuario.nombreContratista = this.decrypt(user.usuario.nombreContratista  , this.secretKey);
					user.usuario.idEmpresa = Number(this.decrypt(user.usuario.idEmpresa  , this.secretKey));
					user.usuario.usuarioEncargado = this.decrypt(user.usuario.usuarioEncargado  , this.secretKey);

				});
				this.usuarios = results[0];
				this.usuariosFilter = results[0];
				this.rerenderUsuario();

				$("#show-loading").css('display', 'none')
			})
			.catch(error => {
				this.loadingUsuarios = false;
				console.error(error);
				$("#show-loading").css('display', 'none')
			});
	}

	decrypt(ciphertext: string, secretKey: string): string {
		const key = CryptoJS.enc.Utf8.parse(secretKey);
		const decryptedBytes = CryptoJS.AES.decrypt(ciphertext, key, {
		  mode: CryptoJS.mode.ECB,
		  padding: CryptoJS.pad.Pkcs7
		});
		const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
		return decryptedText;
	  }

	refreshInitial(event) {
		this.loadingUsuarios = true;
		this.inputMessageModal = event;
		this.inputMessageModal2 = 'Espere un momento mientras se cargan los datos ...'
		//$("#buttonLoadingTest").trigger('click');
		this.usuarios = [];
		this.usuariosFilter = [];
		Promise.all([
			this.getUsuarios()
		])
			.then(results => {
				results[0].map((user) => {
					user.usuario.userId = Number(this.decrypt(user.usuario.userId  , this.secretKey));
					user.usuario.roleId = Number(this.decrypt(user.usuario.roleId  , this.secretKey));
					user.usuario.username = this.decrypt(user.usuario.username  , this.secretKey);
					user.usuario.email = this.decrypt(user.usuario.email  , this.secretKey);
					user.usuario.rutTrabajador = this.decrypt(user.usuario.rutTrabajador  , this.secretKey);
					user.usuario.nombreTrabajador = this.decrypt(user.usuario.nombreTrabajador  , this.secretKey);
					user.usuario.apellidoPaterno = this.decrypt(user.usuario.apellidoPaterno  , this.secretKey);
					user.usuario.apellidoMaterno = this.decrypt(user.usuario.apellidoMaterno  , this.secretKey);
					user.usuario.nombreContratista = this.decrypt(user.usuario.nombreContratista  , this.secretKey);
					user.usuario.idEmpresa = Number(this.decrypt(user.usuario.idEmpresa  , this.secretKey));
					user.usuario.usuarioEncargado = this.decrypt(user.usuario.usuarioEncargado  , this.secretKey);

				});
				this.usuarios = results[0];
				this.usuariosFilter = results[0];
				this.rerenderUsuario();

				$("#show-loading").css('display', 'none')
			})
			.catch(error => {
				this.loadingUsuarios = false;
				console.error(error);
				$("#show-loading").css('display', 'none')
			});
	}
	changeSearch(e) {
		let valor = e.target.value
		if (this.usuarios.length > 0) {
			if (valor.length > 1) {
				let word = valor.toLowerCase()
				this.usuarios = this.usuariosFilter.filter(
					(item) => {
						let str = item.usuario.roleId + item.usuario.username + item.usuario.email + item.zonas +
							item.usuario.rutTrabajador + item.usuario.nombreTrabajador + item.usuario.apellidoPaterno + item.usuario.apellidoMaterno + item.usuario.status +
							item.usuario.nombreContratista
						this.usuarios = []
						str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
						return str.toLowerCase().indexOf(word) > -1
					}
				)
			}
		}
		if (valor.length < 2) {
			this.usuarios = []
			this.usuarios = this.usuariosFilter
		}
	}
	getRolLabel(id: number): string {
		return ROL[id - 1].label;
	}

	getEstadoLabel(estado: boolean): string {
		if (estado) {
			return 'Habilitado';
		} else {
			return 'Deshabilitado';
		}
	}

	getLabelZonas(zonas: any): string {
		if (zonas.length > 0) {
			let textoZona = '';
			zonas.forEach(element => {
				textoZona += element.descripcion + ', ';
			});
			const textoZonaLimpio = textoZona.substring(0, textoZona.length - 2);
			return textoZonaLimpio;
		} else {
			return '-';
		}
	}

	tablaUsuarios() {
		this.refresh();
		this.flagZonas = false;
		this.flagCategorias = false;
		this.flagUsuarios = true;
		this.flagEnfoques = false;
		this.flagEjecutores = false;
		this.flagPlanificacion = false;
		this.flagRelatores = false;
		this.flagFocos = false;
	}

	tablaZonas() {
		this.ngOnDestroy();
		this.flagZonas = true;
		this.flagUsuarios = false;
		this.flagCategorias = false;
		this.flagEnfoques = false;
		this.flagEjecutores = false;
		this.flagPlanificacion = false;
		this.flagRelatores = false;
		this.flagFocos = false;
	}

	tablaCategorias() {
		this.ngOnDestroy();
		this.flagZonas = false;
		this.flagUsuarios = false;
		this.flagCategorias = true;
		this.flagEnfoques = false;
		this.flagEjecutores = false;
		this.flagPlanificacion = false;
		this.flagRelatores = false;
		this.flagFocos = false;
	}

	tablaEnfoques() {
		this.ngOnDestroy();
		this.flagZonas = false;
		this.flagUsuarios = false;
		this.flagCategorias = false;
		this.flagEnfoques = true;
		this.flagEjecutores = false;
		this.flagPlanificacion = false;
		this.flagRelatores = false;
		this.flagFocos = false;
	}

	tablaEjecutores() {
		this.ngOnDestroy();
		this.flagZonas = false;
		this.flagUsuarios = false;
		this.flagCategorias = false;
		this.flagEnfoques = false;
		this.flagEjecutores = true;
		this.flagPlanificacion = false;
		this.flagRelatores = false;
		this.flagFocos = false;
	}

	tablaFocos() {
		this.ngOnDestroy();
		this.flagZonas = false;
		this.flagUsuarios = false;
		this.flagCategorias = false;
		this.flagEnfoques = false;
		this.flagEjecutores = false;
		this.flagPlanificacion = false;
		this.flagRelatores = false;
		this.flagFocos = true;
	}

	tablaRelatores() {
		this.ngOnDestroy();
		this.flagZonas = false;
		this.flagUsuarios = false;
		this.flagCategorias = false;
		this.flagEnfoques = false;
		this.flagEjecutores = false;
		this.flagPlanificacion = false;
		this.flagRelatores = true;
		this.flagFocos = false;
	}

	tablaPlanificacion() {
		this.ngOnDestroy();
		this.flagZonas = false;
		this.flagUsuarios = false;
		this.flagCategorias = false;
		this.flagEnfoques = false;
		this.flagEjecutores = false;
		this.flagPlanificacion = true;
		this.flagRelatores = false;
		this.flagFocos = false;
	}
}
